import Overdraft from './views/index.c';

export default Overdraft;
